import axios from 'axios'
import config from '@/config.js'
import exportConvert from '@/store/export.convert.js'
import { getStatic, readOnlyError } from '@/services/data-source.js'
import { normalizeDocumentTokens } from '@/services/document-token.js'

const API_URL = config.apiUrl

const state = {
  tokens: []
}

const mutations = {
  setTokens(state, tokens){
    state.tokens = tokens
  }
}

const getters = {
}

const actions = {
  updateToken(_, data){
    if (!config.editable) {
      return readOnlyError('Updating a token')
    }
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/token/${data.token_id}/update-xml`, data)
        .then(response => {
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  },
  async loadTokensForDocument({ commit }, data){
    const documentId = typeof data === 'string' ? data : data.documentId
    const document = typeof data === 'string' ? null : data.document
    const request = config.staticData
      ? getStatic(`document/${documentId.slice(0, 2)}/tokens-${documentId}.json`)
      : axios.get(`${API_URL}/document/${documentId}/tokens`)
    return request
      .then(r => r.data)
      .then(async tokens => {
        if (config.staticData) {
          tokens = await Promise.all(
            tokens.map(token => exportConvert.convert('documentToken', token))
          )
        }
        tokens = normalizeDocumentTokens(tokens, document, {
          inferTokenType: config.staticData,
        })
        commit('setTokens', tokens)
        return tokens
      })
  },
  deleteToken(_, tokenId){
    if (!config.editable) {
      return readOnlyError('Deleting a token')
    }
    return new Promise((resolve) => {
      axios
        .delete(`${API_URL}/token/${tokenId}`)
        .then(response => {
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  },
  splitToken(_, data){
    if (!config.editable) {
      return readOnlyError('Splitting a token')
    }
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/token/${data.tokenId}/split`, data)
        .then(response => {
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  },
  batchTokenActions(_, data){
    if (!config.editable) {
      return readOnlyError('Applying token changes')
    }
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/token/batchactions`, data)
        .then(response => {
          resolve(response)
        })
        .catch(async (err) => {
            const message = await err.response.data.message
            this.dispatch('addNotification', {
              type: 'danger',
              text: message || 'token changes could not be applied'
            })
        })
    })
  },
}

export default {
    state,
    getters,
    actions,
    mutations
}
